import { cn } from "utils/cn";

interface ConfidenceIndicatorProps {
  confidenceLevel: 1 | 2 | 3;
  className?: string;
}

const IndicatorNode = ({ isFilled, className }: { isFilled: boolean, className?: string }) => {
  return (
    <div
      className={cn(
        "w-5 h-1 rounded-sm border-[.5px] border-solid border-outline-charcoal-400",
        isFilled ? "bg-primary-teal" : "bg-neutral-charcoal-100",
        className
      )}
    />
  )
};

const ConfidenceIndicator = ({ confidenceLevel, className }: ConfidenceIndicatorProps) => {
  const confidenceLevelLabels = {
    1: "Low",
    2: "Medium",
    3: "High"
  };
  
  return (
    <div className={cn("flex items-center", className)}>
      <IndicatorNode isFilled={confidenceLevel >= 1} />
      <IndicatorNode isFilled={confidenceLevel >= 2} className="mx-[3px]" />
      <IndicatorNode isFilled={confidenceLevel >= 3} className="mr-[5px]"/>
      <p className="font-semibold text-xs">{confidenceLevelLabels[confidenceLevel]}</p>
    </div>
  );
};

export default ConfidenceIndicator;